import React from 'react';
import {Alert, Button, Divider, Form, Input, Modal, notification, Select, Space, Typography} from "antd";
import ApiService from "../../../services/ApiService"
import {EsriProvider} from 'leaflet-geosearch';
import ContactIcon from "../../../components/util-components/ContactIcon";
import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"

const provider = new EsriProvider();
const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;

export default class ModalMergeContact extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initialState = {
        visible: false,
        loading: false,
        contact: null,
        contacts: [],
        mergeContactId: null
    };

    state = this.initialState

    async show(contact) {
        await this.initContact(contact)
        this.setState({visible: true, contact: contact})
    }

    async initContact(contact) {
        var res = await ApiService.get("/contact/form?noContact=" + contact.id)
        this.setState({contacts: res.data})
    }

    onSearch = (text) => {
        this.setState({text});
    }

    close() {
        this.setState(this.initialState)
    }

    async onSelect() {
        if (!this.state.mergeContactId) {
            return false
        }

        var res = await ApiService.post("/contact/merge/" + this.state.mergeContactId + "/" + this.state.contact.id)

        if (res.success) {
            notification.success({
                message: t`Fusion réussie`
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish(this.state.mergeContactId)
            }
        } else {
            notification.error({
                message: t`Erreur lors de la fusion`
            })
        }
    }

    render() {
        const contact = this.state.contact || {}

        return (
            <Modal
                width="100%"
                title={t`Fusionner des contacts`}
                open={this.state.visible}
                destroyOnClose
                closable
                footer={null}
                onCancel={() => this.close()}
            >
                <div style={{display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20}}>
                    <Space>
                        <ContactIcon contact={contact}/> <Text>{contact.nom} {contact.prenom}</Text>
                    </Space>
                </div>

                <Divider dashed>
                    <Text type="danger"><Trans>SERA ÉCRASÉ PAR</Trans></Text>
                </Divider>

                <Form>
                    <Form.Item>
                        <Select
                            showSearch
                            filterOption={(input, option) => {
                                var text = option.props.children
                                if (Array.isArray(text)) {
                                    text = text.join("")
                                }
                                return text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }}
                            placeholder={t`Choisir un autre contact`}
                            value={this.state.mergeContactId}
                            onSelect={(value) => {
                                this.setState({mergeContactId: value})
                            }}
                        >
                            {this.state.contacts.map((item, index) => {

                                var email = ""
                                if (item.email) {
                                    email = "(" + item.email + ")"
                                }

                                var tel = ""
                                if (item.tel) {
                                    tel = "(" + item.tel + ")"
                                }

                                return (
                                    <Select.Option key={index} value={item.id}>
                                        <ContactIcon contact={item}/> {item.nom} {item.prenom} {tel} {email}
                                    </Select.Option>
                                )
                            })}
                        </Select>
                    </Form.Item>

                    <Alert
                        type="warning"
                        message={t`Les informations du contact seront écrasées par le nouveau contact choisi (cette action est irréversible).`}
                    />

                    <Form.Item style={{display: "flex", justifyContent: "flex-end", marginTop: 20}}>
                        <Button type="primary" onClick={() => this.onSelect()} loading={this.state.loading}>
                            <Trans>Valider</Trans>
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}
